import { find, remove, replace } from 'lodash';
import { savedListTypes } from '../utils';

import { search } from '../api';
import {
    addPlayerToList,
    addSchoolToList,
    checkIfListExists,
    createList,
    createPlayerList,
    deleteList,
    deletePlayerList,
    getAllLists,
    getListDetail,
    getNotificationPreferences,
    getPlayerLists,
    getPlayerSavedStatus as getPlayerSavedStatusApi,
    getPlayersSavedStatus as getPlayersSavedStatusApi,
    markListViewed,
    removePlayerFromAllLists as removePlayerFromAllListsApi,
    removePlayerFromList,
    removeSavedListPlayer as removeSavedListPlayerApi,
    removeSchoolFromList,
    renameList,
    savePlayersToLists,
    searchListPlayers,
    searchPlayerLists,
    updateItemNotes,
    updateNotificationPreferences,
    updatePlayerNote,
} from '../api/savedListsApi';
import {
    showErrorPopup,
    showErrorToast,
    showSuccessPopup,
    showSuccessToast,
} from './notification-actions';
import {
    SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_FAILURE,
    SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_REQUEST,
    SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_SUCCESS,
    SAVED_LISTS_PLAYER_MARKED_SAVED,
    SAVED_LISTS_PLAYER_MARKED_UNSAVED,
    SAVED_LISTS_REQUEST_OPEN_LIST,
    SAVED_LISTS_CLEAR_OPEN_LIST,
    SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_FAILURE,
    SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_REQUEST,
    SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_SUCCESS,
} from './actionTypes/saved-lists-action-types';

export const SAVED_PLAYER_LIST_DELETE_TOAST = {
    successTitle: 'List Deleted',
    successMessage: 'Your list has been deleted.',
    errorTitle: 'Something Went Wrong',
    errorMessage: 'We couldn\'t delete this list. Please try again.',
};

export const REMOVE_SAVED_LIST_PLAYER_TOAST = {
    successTitle: 'Player Successfully Removed',
    successMessage: 'Player has been removed from your list.',
    errorTitle: 'Something Went Wrong',
    errorMessage: 'We couldn\'t remove this player from your list. Please try again.',
};

export const NOTIFICATION_PREFERENCES_TOAST = {
    successTitle: 'Notifications Settings Updated',
    enabledMessage: 'You will be notified of new player activity once a week.',
    disabledMessage: 'You will no longer receive notifications for your Saved Player Lists',
    errorTitle: 'Something Went Wrong',
    errorMessage: 'We couldn\'t update your notification settings. Please try again.',
};

export function showPlayersFromSelectedList() {
    return (dispatch, getState) => {
        const { playerLists, selectedPlayerListId } = getState().savedLists;
        if (selectedPlayerListId) {
            const { players } = find(playerLists, { id: selectedPlayerListId });
            dispatch({
                type: 'SAVED_LISTS:SET_PLAYER_LIST',
                data: { savedPlayers: players },
            });
        } else {
            dispatch({
                type: 'SAVED_LISTS:SET_PLAYER_LIST',
                data: { savedPlayers: [] },
            });
        }
    };
}

export function showSchoolsFromSelectedList() {
    return (dispatch, getState) => {
        const { schoolLists, selectedSchoolListId } = getState().savedLists;
        if (selectedSchoolListId) {
            const { schools } = find(schoolLists, { id: selectedSchoolListId });
            dispatch({
                type: 'SAVED_LISTS:SET_SCHOOL_LIST',
                data: { savedSchools: schools },
            });
        } else {
            dispatch({
                type: 'SAVED_LISTS:SET_SCHOOL_LIST',
                data: { savedSchools: [] },
            });
        }
    };
}

export function setSelectedListIds(selectedListId, listType) {
    const getSelectedId = (array, selectedId) => {
        if (array) {
            const selectedItem = find(array, { id: selectedId });
            if (selectedItem) {
                return selectedItem.id;
            }
            if (array.length > 0) {
                return array[0].id;
            }
        }
    };

    return (dispatch, getState) => {
        const {
            playerLists,
            schoolLists,
            selectedPlayerListId,
            selectedSchoolListId,
        } = getState().savedLists;
        const localSelectedPlayerId =
      listType === savedListTypes.players.key
          ? selectedListId || selectedPlayerListId
          : selectedPlayerListId;
        const localSelectedSchoolId =
      listType === savedListTypes.schools.key
          ? selectedListId || selectedSchoolListId
          : selectedSchoolListId;
        const selPlayerListId = getSelectedId(playerLists, localSelectedPlayerId);
        const selSchoolrListId = getSelectedId(schoolLists, localSelectedSchoolId);
        dispatch({
            type: 'SAVED_LISTS:SET_SELECTED_LIST_IDS',
            data: {
                selectedPlayerListId: selPlayerListId,
                selectedSchoolListId: selSchoolrListId,
            },
        });
        dispatch(showPlayersFromSelectedList());
        dispatch(showSchoolsFromSelectedList());
    };
}

export function sortSavedLists() {
    const comparator = (item1, item2) => {
        if (item1.name < item2.name) {
            return -1;
        }
        if (item1.name > item2.name) {
            return 1;
        }
        return 0;
    };

    return (dispatch, getState) => {
        const { playerLists, schoolLists } = getState().savedLists;
        const savedPlayers = playerLists.sort(comparator);
        const savedSchools = schoolLists.sort(comparator);
        dispatch({
            type: 'SAVED_LISTS:SORT_LISTS',
            data: { players: savedPlayers, schools: savedSchools },
        });
    };
}

export function allSavedLists() {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SPLASH_SHOW_LOADING', title: 'Loading' });
        dispatch({ type: 'SAVED_LISTS:GET_ALL_LISTS' });
        getAllLists(mainApi)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({
                        type: 'SAVED_LISTS:GET_ALL_LISTS_FAILURE',
                        data: { players: [], schools: [] },
                    });
                    dispatch({ type: 'SPLASH_HIDE' });
                } else {
                    dispatch({ type: 'SAVED_LISTS:GET_ALL_LISTS_SUCCESS', data });
                    dispatch(sortSavedLists());
                    dispatch(setSelectedListIds());
                    dispatch({ type: 'SPLASH_HIDE' });
                }
            })
            .catch(() => {
                dispatch({
                    type: 'SAVED_LISTS:GET_ALL_LISTS_FAILURE',
                    data: { players: [], schools: [] },
                });
                dispatch({ type: 'SPLASH_HIDE' });
            });
    };
}

export const createSavedList = (listName, playerSchoolId) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    try {
        const { listType, playerLists, schoolLists } = getState().savedLists;
        dispatch({ type: 'SAVED_LISTS:CREATE_LIST', data: { listname: listName } });

        const result = await checkIfListExists(mainApi, listName, listType);
        const { data } = result;
        if (data.isError) {
            dispatch({ type: 'SAVED_LISTS:CREATE_LIST_FAILURE', data });
            throw new Error('exists');
        } else {
            createList(mainApi, listName, listType, playerSchoolId)
                .then((listResult) => {
                    const { data: listData } = listResult;
                    if (listData.isError) {
                        dispatch({ type: 'SAVED_LISTS:CREATE_LIST_FAILURE', data });
                    } else {
                        let newSavedList = [];
                        const newDataInList = { id: listData.id, name: listData.name };
                        newSavedList = listData.listOfPlayerOrSchool.map((dataOption) => {
                            return dataOption;
                        });
                        if (listType === savedListTypes.players.key) {
                            newDataInList.players = newSavedList;
                            playerLists.push(newDataInList);
                        }
                        if (listType === savedListTypes.schools.key) {
                            newDataInList.schools = newSavedList;
                            schoolLists.push(newDataInList);
                        }
                        dispatch({
                            type: 'SAVED_LISTS:CREATE_LIST_SUCCESS',
                            data: { players: playerLists, schools: schoolLists },
                        });
                        dispatch(sortSavedLists());
                        dispatch(setSelectedListIds(listData.id, listType));
                    }
                })
                .catch(() => {
                    dispatch({
                        type: 'SAVED_LISTS:CREATE_LIST_FAILURE',
                        data: { isError: true, errorMessage: 'List Creation Failed' },
                    });
                });
        }
    } catch (err) {
        throw err;
    }
};

export function deleteSavedList(listData) {
    return (dispatch, getState, { mainApi }) => {
        const { playerLists, schoolLists } = getState().savedLists;

        dispatch({ type: 'SAVED_LISTS:DELETE_LIST' });
        deleteList(mainApi, listData.id)
            .then((result) => {
                const { data } = result;
                if (data.isError) {
                    dispatch({ type: 'SAVED_LISTS:DELETE_LIST_FAILURE', data });
                } else {
                    const savedPlayers = playerLists.filter(
                        (player) => player.id !== listData.id,
                    );
                    const savedSchools = schoolLists.filter(
                        (school) => school.id !== listData.id,
                    );
                    dispatch({
                        type: 'SAVED_LISTS:DELETE_LIST_SUCCESS',
                        data: { players: savedPlayers, schools: savedSchools },
                    });
                    dispatch(setSelectedListIds());
                }
            })
            .catch(() => {
                dispatch({ type: 'SAVED_LISTS:DELETE_LIST_FAILURE' });
            });
    };
}

export function addItemInData(itemData, listId, listType) {
    return (dispatch, getState) => {
        const { playerLists, schoolLists } = getState().savedLists;
        if (listType === savedListTypes.players.key) {
            const savedPlayers = find(playerLists, { id: listId }).players;
            if (savedPlayers && !find(savedPlayers, { savedId: itemData.savedId })) {
                find(playerLists, { id: listId }).players.push(itemData);
            } else {
                replace(playerLists, { savedId: itemData.savedId }, itemData);
            }
        } else if (listType === savedListTypes.schools.key) {
            const savedSchools = find(schoolLists, { id: listId }).schools;
            if (savedSchools && !find(savedSchools, { savedId: itemData.savedId })) {
                find(schoolLists, { id: listId }).schools.push(itemData);
            } else {
                replace(schoolLists, { savedId: itemData.savedId }, itemData);
            }
        }
        dispatch({
            type: 'SAVED_LISTS:UPDATE_DATA',
            data: { players: playerLists, schools: schoolLists },
        });
        dispatch(setSelectedListIds());
    };
}

export function addPlayerToSavedList(playerId) {
    return (dispatch, getState, { mainApi }) => {
        const { selectedPlayerListId } = getState().savedLists;
        dispatch({ type: 'SAVED_LISTS:ADD_PLAYER_TO_LIST' });
        addPlayerToList(mainApi, playerId, selectedPlayerListId)
            .then((result) => {
                const { data } = result;
                if (data.isError) {
                    dispatch({ type: 'SAVED_LISTS:ADD_PLAYER_TO_LIST_FAILURE' });
                    dispatch(showErrorPopup({
                        error: 'Saving to list failed',
                    }));
                } else {
                    dispatch({ type: 'SAVED_LISTS:ADD_PLAYER_TO_LIST_SUCCESS' });
                    dispatch(
                        addItemInData(
                            data,
                            selectedPlayerListId,
                            savedListTypes.players.key,
                        ),
                    );
                    dispatch(showSuccessPopup({
                        message: 'Successfully saved to list!',
                    }));
                }
            })
            .catch((error) => {
                dispatch({ type: 'SAVED_LISTS:ADD_PLAYER_TO_LIST_FAILURE' });
                dispatch(showErrorPopup({
                    message: 'Saving to list failed',
                    error,
                }));
            });
    };
}

export function removeItemInData(itemId, listId, listType) {
    return (dispatch, getState) => {
        const { playerLists, schoolLists } = getState().savedLists;
        if (listType === savedListTypes.players.key) {
            remove(find(playerLists, { id: listId }).players, (savedItem) => {
                return savedItem.item.id === itemId;
            });
        } else if (listType === savedListTypes.schools.key) {
            remove(find(schoolLists, { id: listId }).schools, (savedItem) => {
                return savedItem.item.id === itemId;
            });
        }
        dispatch({
            type: 'SAVED_LISTS:UPDATE_DATA',
            data: { players: playerLists, schools: schoolLists },
        });
        dispatch(setSelectedListIds());
    };
}

export function removePlayerFromSavedList(playerId) {
    return (dispatch, getState, { mainApi }) => {
        const { selectedPlayerListId } = getState().savedLists;
        dispatch({ type: 'SAVED_LISTS:REMOVE_PLAYER_FROM_LIST' });
        removePlayerFromList(mainApi, playerId, selectedPlayerListId)
            .then((result) => {
                const { data } = result;
                if (data.isError) {
                    dispatch({ type: 'SAVED_LISTS:REMOVE_PLAYER_FROM_LIST_FAILED' });
                } else {
                    dispatch({ type: 'SAVED_LISTS:REMOVE_PLAYER_FROM_LIST_SUCCESS' });
                    dispatch(
                        removeItemInData(
                            playerId,
                            selectedPlayerListId,
                            savedListTypes.players.key,
                        ),
                    );
                }
            })
            .catch(() => {
                dispatch({ type: 'SAVED_LISTS:REMOVE_PLAYER_FROM_LIST_FAILED' });
            });
    };
}

export function addSchoolToSavedList(schoolClubId) {
    return (dispatch, getState, { mainApi }) => {
        const { selectedSchoolListId } = getState().savedLists;
        dispatch({ type: 'SAVED_LISTS:ADD_SCHOOL_TO_LIST' });
        addSchoolToList(mainApi, schoolClubId, selectedSchoolListId)
            .then((result) => {
                const { data } = result;
                if (data.isError) {
                    dispatch({ type: 'SAVED_LISTS:ADD_SCHOOL_TO_LIST_FAILURE' });
                    dispatch(showErrorPopup({
                        message: 'Saving to list failed',
                    }));
                } else {
                    dispatch({ type: 'SAVED_LISTS:ADD_SCHOOL_TO_LIST_SUCCESS' });
                    dispatch(
                        addItemInData(
                            data,
                            selectedSchoolListId,
                            savedListTypes.schools.key,
                        ),
                    );
                    dispatch(showErrorPopup({
                        custom: true,
                        message: 'Successfully saved to list!',
                    }));
                }
            })
            .catch((error) => {
                dispatch({ type: 'SAVED_LISTS:ADD_SCHOOL_TO_LIST_FAILURE' });
                dispatch(showErrorPopup({
                    message: 'Saving to list failed',
                    error,
                }));
            });
    };
}

export function removeSchoolFromSavedList(schoolClubId) {
    return (dispatch, getState, { mainApi }) => {
        const { selectedSchoolListId } = getState().savedLists;
        dispatch({ type: 'SAVED_LISTS:REMOVE_SCHOOL_FROM_LIST' });
        removeSchoolFromList(mainApi, schoolClubId, selectedSchoolListId)
            .then((result) => {
                const { data } = result;
                if (data.isError) {
                    dispatch({ type: 'SAVED_LISTS:REMOVE_SCHOOL_FROM_LIST_FAILED' });
                } else {
                    dispatch({ type: 'SAVED_LISTS:REMOVE_SCHOOL_FROM_LIST_SUCCESS' });
                    dispatch(
                        removeItemInData(
                            schoolClubId,
                            selectedSchoolListId,
                            savedListTypes.schools.key,
                        ),
                    );
                }
            })
            .catch(() => {
                dispatch({ type: 'SAVED_LISTS:REMOVE_SCHOOL_FROM_LIST_FAILED' });
            });
    };
}

export function updateNotesLocally(savedId, notes, listType) {
    return (dispatch, getState) => {
        const { playerLists, schoolLists } = getState().savedLists;
        if (listType === savedListTypes.players.key) {
            for (let i = 0; i < playerLists.length; i += 1) {
                const savedItem = find(playerLists[i].players, { savedId });
                if (savedItem) {
                    savedItem.notes = notes;
                }
            }
        } else if (listType === savedListTypes.schools.key) {
            for (let i = 0; i < schoolLists.length; i += 1) {
                const savedItem = find(schoolLists[i].schools, { savedId });
                if (savedItem) {
                    savedItem.notes = notes;
                }
            }
        }
        dispatch({
            type: 'SAVED_LISTS:UPDATE_DATA',
            data: { players: playerLists, schools: schoolLists },
        });
        dispatch(setSelectedListIds());
    };
}

export function updateNotes(savedId, notes) {
    return (dispatch, getState, { mainApi }) => {
        const { listType } = getState().savedLists;
        dispatch({ type: 'SAVED_LISTS:UPDATE_NOTES' });
        updateItemNotes(mainApi, savedId, notes, listType)
            .then((result) => {
                const { data } = result;
                if (data.isError) {
                    dispatch({ type: 'SAVED_LISTS:UPDATE_NOTES_FAILED' });
                } else {
                    dispatch({ type: 'SAVED_LISTS:UPDATE_NOTES_SUCCESS' });
                    dispatch(updateNotesLocally(savedId, notes, listType));
                }
            })
            .catch(() => {
                dispatch({ type: 'SAVED_LISTS:UPDATE_NOTES_FAILED' });
            });
    };
}

export function changeListType(listType) {
    return (dispatch) => {
        dispatch({ type: 'SAVED_LISTS:CHANGE_LIST_TYPE', listType });
    };
}

export function changeFilter(filterSelection) {
    return (dispatch, getState) => {
        const { listType } = getState().savedLists;
        dispatch({
            type: 'SAVED_LISTS:CHANGE_SORT_FILTER',
            data: { value: filterSelection.value, listType },
        });
        dispatch(showPlayersFromSelectedList());
        dispatch(showSchoolsFromSelectedList());
    };
}

export function searchForSave({ value, listType, power6SortField }) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'SAVED_LISTS:SEARCH_REQUEST' });
        const filters = {
            type: listType,
        };
        let sort;
        if (listType === savedListTypes.schools.key && power6SortField) {
            sort = {
                asc: false,
                field: power6SortField,
            };
        }
        const { coreUI } = getState();
        search(mainApi, coreUI, {
            query: value,
            filters,
            sort,
            top: 10,
            skip: 0,
            appendType: true,
        })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'SAVED_LISTS:SEARCH_FAILURE' });
                } else {
                    dispatch({ type: 'SAVED_LISTS:SEARCH_SUCCESS', data });
                }
            })
            .catch(() => {
                dispatch({ type: 'SAVED_LISTS:SEARCH_FAILURE' });
            });
    };
}

export const asyncSearchForSaveV2 = ({ value, listType, power6SortField }) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    let responseData;
    const filters = {
        type: listType,
    };
    let sort;
    if (listType === savedListTypes.schools.key && power6SortField) {
        sort = {
            asc: false,
            field: power6SortField,
        };
    }
    const { coreUI } = getState();
    try {
        const searchResponse = await search(mainApi, coreUI, {
            query: value,
            filters,
            sort,
            top: 10,
            skip: 0,
            appendType: true,
        });
        const { data } = searchResponse;
        if (data.error) {
            responseData = [];
        }
        responseData = data;
        return responseData;
    } catch (error) {
        return [];
    }
};

export function getPlayerSavedStatus(playerId) {
    return (dispatch, getState, { mainApi }) => getPlayerSavedStatusApi(mainApi, playerId);
}

export function getPlayersSavedStatus(playerIds) {
    return (dispatch, getState, { mainApi }) => getPlayersSavedStatusApi(mainApi, playerIds);
}

export function getSavedPlayerLists() {
    return (dispatch, getState, { mainApi }) => getPlayerLists(mainApi);
}

export function createSavedPlayerList(name) {
    return (dispatch, getState, { mainApi }) => createPlayerList(mainApi, name);
}

export function getSavedPlayerListDetail(listId) {
    return (dispatch, getState, { mainApi }) => getListDetail(mainApi, listId);
}

export function renameSavedPlayerList(listId, name) {
    return (dispatch, getState, { mainApi }) => renameList(mainApi, listId, name);
}

export function searchSavedPlayerLists({ search, orderBy, orderByRules, page, size }) {
    return (dispatch, getState, { mainApi }) => searchPlayerLists(mainApi, {
        search,
        orderBy,
        orderByRules,
        page,
        size,
    });
}

export function searchSavedListPlayers({ listId, search, orderBy, orderByRules, page, size, viewedAsOf }) {
    return (dispatch, getState, { mainApi }) => searchListPlayers(mainApi, {
        listId,
        search,
        orderBy,
        orderByRules,
        page,
        size,
        viewedAsOf,
    });
}

export function markSavedListViewed(listId) {
    return (dispatch, getState, { mainApi }) => markListViewed(mainApi, listId);
}

// Thin pass-through (mirrors renameSavedPlayerList): the List Detail row owns the busy state and the
// targeted local row patch, so this just performs the write and resolves. An empty note clears it.
export function updateSavedListPlayerNote(playerId, note) {
    return (dispatch, getState, { mainApi }) => updatePlayerNote(mainApi, playerId, note);
}

export function deleteSavedPlayerList(listId) {
    return (dispatch, getState, { mainApi }) => deletePlayerList(mainApi, listId)
        .then((result) => {
            dispatch(showSuccessToast({
                title: SAVED_PLAYER_LIST_DELETE_TOAST.successTitle,
                message: SAVED_PLAYER_LIST_DELETE_TOAST.successMessage,
            }));
            return result;
        })
        .catch((error) => {
            dispatch(showErrorToast({
                title: SAVED_PLAYER_LIST_DELETE_TOAST.errorTitle,
                message: SAVED_PLAYER_LIST_DELETE_TOAST.errorMessage,
            }));
            throw error;
        });
}

export function removeSavedListPlayer(listId, playerId) {
    return (dispatch, getState, { mainApi }) => removeSavedListPlayerApi(mainApi, listId, playerId)
        .then((result) => {
            dispatch(showSuccessToast({
                title: REMOVE_SAVED_LIST_PLAYER_TOAST.successTitle,
                message: REMOVE_SAVED_LIST_PLAYER_TOAST.successMessage,
            }));
            return result;
        })
        .catch((error) => {
            dispatch(showErrorToast({
                title: REMOVE_SAVED_LIST_PLAYER_TOAST.errorTitle,
                message: REMOVE_SAVED_LIST_PLAYER_TOAST.errorMessage,
            }));
            throw error;
        });
}

export function savePlayersToSavedLists({ playerIds, listIds, newListName }) {
    return (dispatch, getState, { mainApi }) => savePlayersToLists(mainApi, {
        playerIds,
        listIds,
        newListName,
    }).then((result) => {
        // Persist the saved state onto any already-loaded copy of each player (e.g. the event
        // all-players list) so its bookmark stays filled across tab switches without re-fetching
        // that large endpoint. Reducers that hold a copy of the player react to this action —
        // one dispatch per player added.
        playerIds.forEach((playerId) => dispatch({ type: SAVED_LISTS_PLAYER_MARKED_SAVED, playerId }));
        return result;
    });
}

// Single-player convenience wrapper — the multi-player thunk with a one-element array, so the two
// can't drift.
export function savePlayerToLists({ playerId, listIds, newListName }) {
    return savePlayersToSavedLists({ playerIds: [playerId], listIds, newListName });
}

// List Detail opens from SavedListsTabContent's local state, so a success toast fired elsewhere (the
// hub Add-Player "View List" link) can't open it directly. These bridge that: request an open, which
// SavedListsTabContent consumes to select the list, then clears so it fires once.
export function requestOpenSavedList(listId) {
    return (dispatch) => {
        dispatch({ type: SAVED_LISTS_REQUEST_OPEN_LIST, listId });
    };
}

export function clearOpenSavedListRequest() {
    return (dispatch) => {
        dispatch({ type: SAVED_LISTS_CLEAR_OPEN_LIST });
    };
}

export function removePlayerFromAllLists(playerId) {
    return (dispatch, getState, { mainApi }) => removePlayerFromAllListsApi(mainApi, playerId)
        .then((result) => {
            // Without this, an already-loaded copy of the player elsewhere (e.g. the event
            // all-players list) would keep its filled bookmark until a full re-fetch.
            dispatch({ type: SAVED_LISTS_PLAYER_MARKED_UNSAVED, playerId });
            return result;
        });
}

export function fetchSavedListNotificationPreferences() {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_REQUEST });
        return getNotificationPreferences(mainApi)
            .then((result) => {
                const { data } = result;
                if (data?.isError) {
                    dispatch({ type: SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_FAILURE });
                } else {
                    dispatch({
                        type: SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_SUCCESS,
                        data: { notificationsEnabled: !!data?.notificationsEnabled },
                    });
                }
            })
            .catch(() => {
                dispatch({ type: SAVED_LISTS_GET_NOTIFICATION_PREFERENCES_FAILURE });
            });
    };
}

export function updateSavedListNotificationPreferences(notificationsEnabled) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_REQUEST });
        return updateNotificationPreferences(mainApi, notificationsEnabled)
            .then((result) => {
                const { data } = result;
                if (data?.isError) {
                    throw new Error('Failed to update notification preferences');
                }
                dispatch({
                    type: SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_SUCCESS,
                    data: { notificationsEnabled },
                });
                dispatch(showSuccessToast({
                    title: NOTIFICATION_PREFERENCES_TOAST.successTitle,
                    message: notificationsEnabled
                        ? NOTIFICATION_PREFERENCES_TOAST.enabledMessage
                        : NOTIFICATION_PREFERENCES_TOAST.disabledMessage,
                }));
            })
            .catch(() => {
                dispatch({ type: SAVED_LISTS_UPDATE_NOTIFICATION_PREFERENCES_FAILURE });
                dispatch(showErrorToast({
                    title: NOTIFICATION_PREFERENCES_TOAST.errorTitle,
                    message: NOTIFICATION_PREFERENCES_TOAST.errorMessage,
                }));
            });
    };
}
